import { Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import styled from 'styled-components';

const Container = styled.div`
  width: calc(100% - ${(props) => (props.phone ? 12 : 32)}px);
  height: ${(props) => (props.isFocused ? '42px' : '43px')};
  padding: ${(props) => (props.phone ? '0 6px' : '0 16px')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border-radius: 50px;
  background-color: ${(props) => props.bg || 'transparent'};
  font-size: 16px;
  border-width: ${(props) => (props.error || props.isFocused ? '2px' : '1px')};
  border-style: solid;
  border-color: ${(props) =>
    props.error ? theme.SECONDARY : props.isFocused ? '#000' : theme.GREY_50};

  ${(props) =>
    props.multiline &&
    `
    border-radius: 16px;
    ${props.numberOfLines && `max-height: ${(props.isFocused ? 42 : 43) * props.numberOfLines}px;`}
  `};

  ${(props) =>
    props.ht &&
    `
    height: ${props.ht};
    align-items: flex-start;
  `}
`;

const StyledInput = styled(CurrencyInput)`
  font-family: CeraPro;
  flex: 1;
  width: 100%;
  font-size: 16px;
  text-align: ${(props) => props.align || 'left'};
  ${(props) => props.center && `text-align: center;`};

  ${(props) =>
    props.multiline &&
    `
    padding: 10px 0;
  `};
`;

const CustomInput = (props) => {
  const isPercentage = props.prefix === '%';

  return (
    <React.Fragment>
      {props.title && (
        <Text b2 med marg="0 0 4px 16px">
          {props.title}
        </Text>
      )}

      <Container {...props}>
        <StyledInput
          allowNegativeValue={false}
          onValueChange={props.onValueChange}
          placeholder={props.placeholder}
          align={props.align}
          prefix={props.prefix === '' ? '' : props.prefix || '$'}
          suffix={props.suffix}
          disabled={props.disabled}
          value={props.value}
          defaultValue={props.defaultValue}
          maxLength={isPercentage && 3}
          onChange={props.onChange}
          onFocus={() => props.setIsFocused(true)}
          onBlur={(e) => {
            props.onBlur && props.onBlur(e);
            props.setIsFocused(false);
          }}
          ref={props.inputRef}
        />
      </Container>

      {props.error && (
        <Row noFlex>
          <Text c1 bold marg="4px 0 0 16px" col={theme.SECONDARY}>
            {props.error}
          </Text>
        </Row>
      )}
    </React.Fragment>
  );
};

export default CustomInput;
